import List from "@/components/list";
import { tableBaseProps } from '@/utils/common.js';

const Table = (args) => {
  const { listeners, props } = args;
  const selectionChange = listeners["selectionChange"] || function () { };
  const del = listeners["del"] || function () { };
  const toEdit = listeners["toEdit"] || function () { };
  const goDetail = listeners["goDetail"] || function () { };
  const editMemberInfo = listeners["editMemberInfo"] || function () { };
  const editPost = listeners["editPost"] || function () { };
  const updateGraduateInfo = listeners["updateGraduateInfo"] || function () { };
  const editMemberType = listeners["editMemberType"] || function () { };
  const outSchoolDetail = listeners["outSchoolDetail"] || function () { };


  const Deal = ({ props: { vo } }) => {
    const { row } = vo;

    const editFlag = false, delFlag = false
    const dealConf = [
      [
        "icon-remove",
        "移除",
        () => del(row),
        "classOffline:deleteStudent"
      ],
      [
        "icon-post",
        "编辑班内职务",
        () => editPost(row),
        "classOffline:post"
      ],
      [
        "icon-graduation",
        "修改结业信息",
        () => updateGraduateInfo(row),
        "classOffline:graduation"
      ],
      [
        "icon-edit",
        "修改学员信息",
        () => editMemberInfo(row),
        "classOffline:post"
      ],
      [
        "iconfont ic_a-xiugairenxuanleixing-moren2x iconfont-adapt",
        "修改人选类型",
        () => editMemberType(row),
        "classOffline:updateSuperior"
      ]
    ]


    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  }

  const UserName = ({ props: { vo } }) => {
    const row = vo.row;
    return (
      <div class="base-hover-char" onClick={() => goDetail(row)}>
        {row.userName}
      </div>
    );
  };

  const GradeStatus = ({ props: { vo } }) => {
    const row = vo.row;
    const flag = row.graduationStatus === 2
    return <div class={flag ? "base-hover-char" : ""} onClick={() => {
      flag && outSchoolDetail(row)
    }}>
      {row.graduationStatusName}
    </div>

  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      ...tableBaseProps("姓名", "userName", "80"),
      render: (vo) => <UserName vo={vo} />,
    },
    tableBaseProps("工作单位", "deptName", "m180"),
    tableBaseProps("单位及职务", "unitPosition", "m180"),
    tableBaseProps("班内职务", "classPostName", "100"),
    tableBaseProps("优秀学员", "isExcellentName", "80"),
    {
      ...tableBaseProps("结业状态", "graduationStatusName", "80"),
      render: (vo) => <GradeStatus vo={vo} />,
    },
    tableBaseProps("培训天数", "trainDays", "100"),
    {
      label: "操作",
      fixed: "right",
      width: '130',
      render: vo => <Deal vo={vo} />
    }

  ]
  return <List {...args} talbeCols={AccountTableConfig} onSelectionChange={selectionChange} />;
}
export default Table;
